export function canonicalSteps(config, stepSources) {
  const steps = (config && config.steps) || [];
  if (!steps.some((s) => s && s.workflow_id)) return config;
  const sources = stepSources || [];
  return {
    ...config,
    steps: steps.map((step, i) => {
      if (!step || !step.workflow_id) return step;
      const daId = sources[i] && sources[i].da_id;
      if (!daId) return step;
      const rest = { ...step, da_id: daId };
      delete rest.workflow_id;
      return rest;
    }),
  };
}

function canonicalOpportunity(opportunityConfig, opportunitySource) {
  if (!opportunityConfig || !opportunityConfig.opportunity_workflow_id) return opportunityConfig;
  const daId = opportunitySource && opportunitySource.da_id;
  if (!daId) return opportunityConfig;
  const rest = { ...opportunityConfig, opportunity_primitive_id: daId };
  delete rest.opportunity_workflow_id;
  return rest;
}

export function canonicalRecord(record) {
  if (!record || typeof record !== 'object') return record;
  let out = record;
  if (out.composable_config && out.composable_config.studio_config) {
    const studio = canonicalSteps(out.composable_config.studio_config, out.step_sources);
    if (studio !== out.composable_config.studio_config) {
      out = { ...out, composable_config: { ...out.composable_config, studio_config: studio } };
    }
  } else if (out.studio_config) {
    const studio = canonicalSteps(out.studio_config, out.step_sources);
    if (studio !== out.studio_config) out = { ...out, studio_config: studio };
  }
  if (out.opportunity_config) {
    const opportunity = canonicalOpportunity(out.opportunity_config, out.opportunity_source);
    if (opportunity !== out.opportunity_config) out = { ...out, opportunity_config: opportunity };
  }
  return out;
}
